<template>
	<div class="form-settings">
		<!-- Mode -->
		<div class="form-group">
			<label><b>Mode</b></label>
			<select class="form-control" :value="mode" @change="onModeChange">
				<option v-for="(option, index) in modeOptions" :key="index" :value="option.value">{{ option.label }}</option>
			</select>
		</div>
		<!-- Initial Fields -->
		<div class="form-group" v-if="mode === 'progressive'">
			<label><b>Initial Fields</b></label>
			<select class="form-control" :value="initialFields" @change="onFieldsChange">
				<option v-for="index in fieldsLength" :key="index" :value="index">{{ index }}</option>
			</select>
		</div>
		<!-- Label -->
		<div class="form-group">
			<label><b>Label</b></label>
			<select class="form-control" :value="label" @change="onLabelChange">
				<option v-for="(option, index) in labelOptions" :key="index" :value="option.value">{{ option.label }}</option>
			</select>
		</div>
	</div>
</template>

<script>
import { formModes } from '../lib/statics';

export default {
	name: 'FormSettings',
	props: {
		label: {
			type: Boolean,
			default: false,
		},
		mode: {
			type: String,
			default: 'all',
		},
		initialFields: {
			type: Number,
			default: 1,
		},
		fields: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			modeOptions: formModes,
			labelOptions: [
				{ value: false, label: 'Hide Label' },
				{ value: true, label: 'Show Label' },
			],
		};
	},
	methods: {
		onModeChange(event) {
			const mode = event.target.value;
			this.$emit('update:mode', mode);
		},
		onFieldsChange(event) {
			const initialFields = parseInt(event.target.value);
			this.$emit('update:initialFields', initialFields);
		},
		onLabelChange(event) {
			const labelString = event.target.value;
			const label = labelString === 'true';
			this.$emit('update:label', label);
		},
	},
	computed: {
		fieldsLength() {
			return this.fields.filter(({ enabled }) => enabled).length;
		},
	},
};
</script>
